import { useParams } from 'react-router-dom';

export const useSlug = () => {
    const { slug } = useParams();

    const numberSlug = Number(slug);
    const isValidSlug = Boolean(numberSlug);

    return { slug: numberSlug, isValidSlug };
};
